/**
 * Skeleton card component for employee card loading states
 * @module components/common/SkeletonCard
 */

import React from 'react'
import { SkeletonCircular, SkeletonText, SkeletonRounded } from './Skeleton'

export interface SkeletonCardProps {
  /**
   * Number of cards to display
   */
  count?: number
}

/**
 * Skeleton card component matching employee card structure
 *
 * Displays avatar, name, role, department, and status badge skeleton
 */
export const SkeletonCard: React.FC<SkeletonCardProps> = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="mb-4 rounded-lg border border-border bg-card p-4"
        >
          <div className="flex items-center gap-4">
            {/* Avatar */}
            <SkeletonCircular width={48} height={48} />

            {/* Employee info */}
            <div className="flex-1 space-y-2">
              <SkeletonText width="60%" height={20} />
              <SkeletonText width="40%" height={16} />
              <SkeletonText width="50%" height={14} />
            </div>

            {/* Status badge */}
            <SkeletonRounded width={80} height={24} />
          </div>
        </div>
      ))}
    </>
  )
}
